// src/components/security/ProtectedRoute.js

import React from "react";
import useRole from "../../hooks/useRole";

function ProtectedRoute({ allowedRoles = [], children }) {
  const roleInfo = useRole();

  if (roleInfo.loading) {
    return (
      <div style={{ padding: "24px" }}>
        <h2>Checking access...</h2>
      </div>
    );
  }

  if (!roleInfo.active) {
    return (
      <div style={{ padding: "24px" }}>
        <h1>Access Denied</h1>
        <p>Your account is not active for this application.</p>
      </div>
    );
  }

  if (!allowedRoles.includes(roleInfo.role)) {
    return (
      <div style={{ padding: "24px" }}>
        <h1>Access Denied</h1>
        <p>You do not have permission to open this page.</p>
        <p>
          Current role: <strong>{roleInfo.role}</strong>
        </p>
      </div>
    );
  }

  return children;
}

export default ProtectedRoute;